"use client";
import styles from "./DialogApiSignupForm.module.css";

//#region [Props]
type DialogApiSignupFormProps = {
    value: {
        signupForm: string;
        gdprFormId: number;
    };
};
//#endregion

//#region [Component]
export default function DialogApiSignupForm({ value }: DialogApiSignupFormProps) {

    return <div className={styles.DialogApiForm} dangerouslySetInnerHTML={{ __html: value.signupForm }}></div>

}
//#endregion

//#region [Styles]

//#endregion